import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=f9d58ff4&scoped=true&"
import script from "./footer-info.vue?vue&type=script&lang=js&"
export * from "./footer-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d58ff4",
  null
  
)

export default component.exports